import Select from "ol/interaction/Select";
import { pointerMove } from "ol/events/condition";
import { SDOControl } from "../controls/SDOControl";
import { getSDOLayer, TrafficSign } from "../layers/SDOLayer";

export function addSDOLayersAndControls(
  map,
  azureLoginControl,
  dateInputControl,
  target,
) {
  // Initialization of the SDO checkbox control.
  const sdoControl = new SDOControl({
    target: target,
  });
  // Initialization of the OpenLayers layer that will be added to the Map.
  // This layer contains all the traffic signs (SDOs).
  const sdoLayer = getSDOLayer(dateInputControl, sdoControl, azureLoginControl);
  map.addLayer(sdoLayer);
  map.addControl(sdoControl);
  // These are some forced updates that trigger certain onpropertychange events in getSDOLayer and SDOControl.
  // Default behaviour: SDO is turned on and should therefore be set immediately when the page is loaded.
  // The bbox is set before the sdoToggle because otherwise the propertychange listener in getSDOLayer would have
  // an undefined bbox.
  sdoControl.set("bbox", map.getView().calculateExtent(map.getSize()));
  sdoControl.set("sdoToggle", false);
  // The on moveend event listener fires when the mouse is released or the scroll wheel is used to zoom in/out.
  // We only want this on moveend and not on every change, because then the API would get flooded with useless
  // and aborted calls.
  map.on("moveend", function (event) {
    // Because the map has changed after a moveevent, the bounding box of the map is set as a property of sdoControl
    // which can then be used in the API call.
    sdoControl.set(
      "bbox",
      event.target.getView().calculateExtent(event.target.getSize()),
    );
  });

  // The SDO layer is also add statically to every TrafficSign instance, to be able
  // to force the layer to rerender when the scale of an object has changed.
  TrafficSign.sdoLayer = sdoLayer;

  // This Select Interaction is used to check for hover updates of the SDO objects.
  let hoverSelect = new Select({
    condition: pointerMove,
  });
  // This line is used to be able to get the styles of the features that were selected and deselected by the mouse pointer.
  // ! Weird: see https://github.com/openlayers/openlayers/issues/10131.
  hoverSelect.style_ = null;
  hoverSelect.on("select", TrafficSign.hoverSelectHandler);
  map.addInteraction(hoverSelect);
}
